import React, { Component } from "react";
import { Receiver } from "react-file-uploader";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import Constant from "../../../Constant";

export default class Audio extends Component {
  constructor(props) {
    super(props);
    console.log("props", this.props);
    this.state = {
      name: props.name || "",
      description: props.desc || "",
      selectedFiles: null,
      videoURL: null,
      image: props.image || "",
      video: props.content || "",
      topicCatagoryId: "audio",
      courseID: this.props.data,
    };
  }

  onInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  uploadImage = (event) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new FormData();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("media", event.target.files[0]);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/media/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result.data[0]);
        this.setState({
          image: result.data[0],
        });
      })
      .catch((error) => console.log("error", error));
  };

  uploadAudio = (event) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new FormData();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("media", event.target.files[0]);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/media/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result.data[0]);
        this.setState({
          video: result.data[0],
        });
      })
      .catch((error) => console.log("error", error));
  };

  onSubmit = (event) => {
    event.preventDefault();
    const {
      name,
      description,
      topicCatagoryId,
      image,
      video,
      courseID,
    } = this.state;
    const data = {
      name: name,
      description: description,
      image: image,
      content: {
        video: video,
        topicType: topicCatagoryId,
      },
      contentType: topicCatagoryId,
      courseId: courseID,
    };
    console.log(data);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    let urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", data.courseId);
    urlencoded.append("name", data.name);
    urlencoded.append("description", data.description);
    urlencoded.append("image", data.image);
    urlencoded.append("content", JSON.stringify(data.content));
    urlencoded.append("contentType", data.contentType);
    urlencoded.append("start", new Date().toISOString());
    // urlencoded.append("end", data.contentType);
    urlencoded.append("isLive", false);
    urlencoded.append("duration", "15");
    let postRequestOption = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };
    fetch(Constant.getAPI() + "/topic/add", postRequestOption)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
      })
      .catch((error) => console.log("error", error));
  };

  onUpdate = (event) => {
    event.preventDefault();
    const {
      name,
      description,
      topicCatagoryId,
      image,
      video,
      courseID,
    } = this.state;
    const data = {
      name: name,
      description: description,
      image: image,
      content: {
        video: video,
        topicType: topicCatagoryId,
      },
      contentType: topicCatagoryId,
      courseId: courseID,
    };
    console.log("audio update", data);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    let urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("topicId", this.props.topicID);
    urlencoded.append("name", data.name);
    urlencoded.append("description", data.description);
    urlencoded.append("image", data.image);
    urlencoded.append("content", JSON.stringify(data.content));
    urlencoded.append("contentType", data.contentType);
    urlencoded.append("start", new Date().toISOString());
    // urlencoded.append("end", data.contentType);
    urlencoded.append("isLive", false);
    urlencoded.append("duration", "15");
    let postRequestOption = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };
    fetch(Constant.getAPI() + "/topic/update", postRequestOption)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    return (
      <div>
        <hr />
        <div class="form-group">
          <div className="col-md-10">
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Topic Name
              </label>
              <input
                type="text"
                class="form-control col-8"
                placeholder="Enter Topic Name"
                id="inputDefault"
                name="name"
                value={this.state.name}
                onChange={this.onInputChange}
              />
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Discription
              </label>
              <textarea
                type="text"
                class="form-control col-8"
                placeholder="Add Topic Discription"
                id="inputDefault"
                name="description"
                value={this.state.description}
                onChange={this.onInputChange}
              />
            </div>

            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Upload Audio
              </label>
              <input
                type="file"
                name="selectedFile"
                onChange={this.uploadAudio}
                multiple
              />
              <div className="col-8 p-0"></div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Catagory Type
              </label>
              <input
                type="text"
                class="form-control col-8"
                value="Audio"
                readOnly
              />
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Topic Image
              </label>
              <input
                type="file"
                name="selectedFile"
                onChange={this.uploadImage}
              />
              <div className="col-8 p-0"></div>
            </div>

            <div className="row">
              <div className="col-4"></div>
              <div className="col-8 p-0">
                {this.props.name ? (
                  <button onClick={this.onUpdate} className="btn btn-primary">
                    Edit and View
                  </button>
                ) : (
                  <button onClick={this.onSubmit} className="btn btn-primary">
                    Save and View
                  </button>
                )}{" "}
                or{" "}
                <a href={`#/admin/course/topics/${this.state.courseID}`}>
                  Cancel
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
